import React from 'react';
import { Document, Page, Text, View, Image, StyleSheet } from '@react-pdf/renderer';

// Base64 encoded logo for PDF rendering
const logoBase64 = 'data:image/png;base64,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';

export type BillData = {
  month: string;
  billNumber: string;
  issueDate: string;
  period: string;
  energyConsumed: string;
  ratePerKwh: string;
  totalAmount: string;
  status: 'paid' | 'pending' | 'overdue';
};

export type BillPDFProps = {
  data: BillData;
  qrDataUrl?: string;
  barcodeDataUrl?: string;
};

const colors = {
  primary: 'rgb(139, 172, 214)',
  primaryLight: 'rgb(139, 172, 214)',
  accent: 'rgb(139, 172, 214)',
  text: '#111827',
  muted: '#6B7280',
  mutedLight: '#9CA3AF',
  divider: '#E5E7EB',
  surface: '#FFFFFF',
  surfaceSecondary: '#F9FAFB',
  success: '#10B981',
  warning: '#F59E0B',
  error: '#EF4444',
};

const styles = StyleSheet.create({
  page: { 
    padding: 32, 
    backgroundColor: colors.surface, 
    color: colors.text, 
    fontSize: 11,
    fontFamily: 'Helvetica'
  },
  header: { 
    flexDirection: 'row', 
    justifyContent: 'space-between', 
    alignItems: 'center', 
    backgroundColor: colors.surfaceSecondary,
    padding: 16,
    borderRadius: 8,
    marginBottom: 24
  },
  logo: { width: 140, height: 46, objectFit: 'contain' },
  company: { textAlign: 'right' },
  companyName: { fontSize: 16, fontWeight: 700, color: colors.primary, marginBottom: 2 },
  companyMeta: { fontSize: 10, color: colors.muted },
  companyTagline: { fontSize: 8, color: colors.accent, fontStyle: 'italic' },
  title: { 
    fontSize: 20, 
    fontWeight: 700, 
    marginBottom: 12,
    color: colors.primary,
    textAlign: 'center'
  },
  subtitle: {
    fontSize: 12,
    color: colors.muted,
    textAlign: 'center',
    marginBottom: 24
  },
  grid: { flexDirection: 'row', gap: 16 },
  col: { flex: 1 },
  row: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 8, alignItems: 'center' },
  label: { color: colors.muted, fontSize: 10 },
  value: { fontWeight: 600, fontSize: 11 },
  billNumber: { fontWeight: 600, fontSize: 9, maxWidth: 160, flexWrap: 'wrap' },
  card: { 
    borderWidth: 1, 
    borderColor: colors.divider, 
    borderRadius: 8, 
    padding: 16, 
    marginBottom: 12,
    backgroundColor: colors.surface,
    shadowColor: colors.muted,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4
  },
  cardHeader: {
    fontSize: 12,
    fontWeight: 700,
    color: colors.primary,
    marginBottom: 8,
    paddingBottom: 6,
    borderBottomWidth: 1,
    borderBottomColor: colors.divider
  },
  statusBadge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    fontSize: 9,
    fontWeight: 600,
    textAlign: 'center'
  },
  statusPaid: { backgroundColor: colors.success, color: colors.surface },
  statusPending: { backgroundColor: colors.warning, color: colors.surface },
  statusOverdue: { backgroundColor: colors.error, color: colors.surface },
  totalCard: {
    backgroundColor: colors.primary,
    borderColor: colors.primary,
    marginTop: 8
  },
  totalLabel: { color: colors.surface, fontWeight: 700, fontSize: 12 },
  totalValue: { color: colors.surface, fontWeight: 700, fontSize: 16 },
  footer: { 
    marginTop: 32, 
    borderTopWidth: 2, 
    borderTopColor: colors.primary, 
    paddingTop: 16, 
    flexDirection: 'row', 
    justifyContent: 'space-between', 
    alignItems: 'center',
    backgroundColor: colors.surfaceSecondary,
    padding: 16,
    borderRadius: 8
  },
  footerText: { color: colors.muted, fontSize: 10 },
  qr: { width: 72, height: 72 },
  barcode: { width: 220, height: 60, objectFit: 'contain' },
});

const getStatusStyle = (status: string) => {
  switch (status) {
    case 'paid': return [styles.statusBadge, styles.statusPaid];
    case 'pending': return [styles.statusBadge, styles.statusPending];
    case 'overdue': return [styles.statusBadge, styles.statusOverdue];
    default: return [styles.statusBadge, styles.statusPending];
  }
};

const BillPDF: React.FC<BillPDFProps> = ({ data, qrDataUrl, barcodeDataUrl }) => (
  <Document>
    <Page size="A4" orientation="portrait" style={styles.page}>
      <View style={styles.header}>
        <Image src={logoBase64} style={styles.logo} />
        <View style={styles.company}>
          <Text style={styles.companyName}>Growth Energy</Text>
          <Text style={styles.companyMeta}>Sustainable Power Solutions</Text>
          <Text style={styles.companyTagline}>Powering Tanzania's Future</Text>
        </View>
      </View>

      <View style={{ marginBottom: 24 }}>
        <Text style={styles.title}>Electricity Bill</Text>
        <Text style={styles.subtitle}>Monthly Energy Consumption Statement</Text>
      </View>

      <View style={styles.grid}>
        <View style={styles.col}>
          <View style={styles.card}>
            <Text style={styles.cardHeader}>Bill Information</Text>
            <View style={styles.row}>
              <Text style={styles.label}>Month:</Text>
              <Text style={styles.value}>{data.month}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Bill Number:</Text>
              <Text style={styles.billNumber}>{data.billNumber}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Issue Date:</Text>
              <Text style={styles.value}>{data.issueDate}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Consumption Period:</Text>
              <Text style={styles.value}>{data.period}</Text>
            </View>
          </View>
        </View>
        <View style={styles.col}>
          <View style={styles.card}>
            <Text style={styles.cardHeader}>Usage & Charges</Text>
            <View style={styles.row}>
              <Text style={styles.label}>Energy Consumed:</Text>
              <Text style={styles.value}>{data.energyConsumed}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Rate per kWh:</Text>
              <Text style={styles.value}>{data.ratePerKwh}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Payment Status:</Text>
              <Text style={getStatusStyle(data.status)}>{data.status.toUpperCase()}</Text>
            </View>
          </View>
        </View>
      </View>

      <View style={[styles.card, styles.totalCard]}>
        <View style={styles.row}>
          <Text style={styles.totalLabel}>TOTAL AMOUNT DUE:</Text>
          <Text style={styles.totalValue}>{data.totalAmount}</Text>
        </View>
      </View>

      <View style={styles.footer}>
        <Text style={styles.footerText}>Verified Document - Growth Energy - Sustainable Power Solutions</Text>
        {qrDataUrl && qrDataUrl.length > 0 && (
          <Image src={qrDataUrl} style={styles.qr} />
        )}
      </View>
    </Page>
  </Document>
);

export default BillPDF;
